<template>
  <div class="trial-framework">
    <section v-if="isShow('primary')" class="level">
      <h2 class="level-branch">小学部</h2>
      <div class="level-grade" v-for="(grade, index) in primary" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, primary, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('middle')" class="level">
      <h2 class="level-branch">中学部</h2>
      <div class="level-grade" v-for="(grade, index) in middle" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, middle, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('high')" class="level">
      <h2 class="level-branch">高中部</h2>
      <div class="level-grade" v-for="(grade, index) in high" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, high, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('secondary')" class="level">
      <h2 class="level-branch">中专部</h2>
      <div class="level-grade" v-for="(grade, index) in secondary" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, secondary, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <p class="frame-tip" v-if="showList && showList.length > 0">
      根据您的学校类型，我们已经为您自动生成一个基本的架构组织。需要您填写相应每个年级的班级数量。如果自动生成的架构不够理想，之后您还可以再系统里面自由修改。
    </p>
    <div v-else class="frame-tip" style="font-size: 14px">
      该类型未预设默认架构，申请成功后可进入管理台自行配置
    </div>
  </div>
</template>

<script>
export default {
  name: 'Framework',

  props: {
    type: { type: String, default: '' }
  },

  data() {
    return {
      primary: [],
      middle: [],
      high: [],
      secondary: []
    }
  },

  computed: {
    grade() {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      // 8月1号之后，定为新一届
      return month < 8 ? year - 1 : year
    },

    showList() {
      let list = []

      if (this.type === '小学') {
        list = ['primary']
      } else if (this.type === '初中') {
        list = ['middle']
      } else if (this.type === '高中') {
        list = ['high']
      } else if (this.type === '九年一贯制') {
        list = ['primary', 'middle']
      } else if (this.type === '初中高中') {
        list = ['middle', 'high']
      } else if (this.type === '十二年一贯制') {
        list = ['primary', 'middle', 'high']
      } else if (this.type === '中职中专') {
        list = ['secondary']
      }

      return list
    }
  },

  methods: {
    handleBlur(count, list, idx) {
      count = parseInt(count) || 0
      if (count < 0) count = 0

      let name = list[idx].term_name
      let newItem = { term_name: name, class_total: count }
      this.$set(list, idx, newItem)
    },

    isShow(flag) {
      return this.showList.includes(flag)
    },

    getLevelData() {
      let levelData = {}

      for (let idx in this.showList) {
        let item = this.showList[idx]
        levelData[item] = this[item]
      }

      levelData = JSON.parse(JSON.stringify(levelData))

      return levelData
    },

    initData() {
      this.primary = [
        { term_name: `一年级${this.grade}级`, class_total: 0 },
        { term_name: `二年级${this.grade - 1}级`, class_total: 0 },
        { term_name: `三年级${this.grade - 2}级`, class_total: 0 },
        { term_name: `四年级${this.grade - 3}级`, class_total: 0 },
        { term_name: `五年级${this.grade - 4}级`, class_total: 0 },
        { term_name: `六年级${this.grade - 5}级`, class_total: 0 }
      ]

      this.middle = [
        { term_name: `初一${this.grade}级`, class_total: 0 },
        { term_name: `初二${this.grade - 1}级`, class_total: 0 },
        { term_name: `初三${this.grade - 2}级`, class_total: 0 }
      ]

      this.high = [
        { term_name: `高一${this.grade}级`, class_total: 0 },
        { term_name: `高二${this.grade - 1}级`, class_total: 0 },
        { term_name: `高三${this.grade - 2}级`, class_total: 0 }
      ]

      this.secondary = [
        { term_name: `中专一年级${this.grade}级`, class_total: 0 },
        { term_name: `中专二年级${this.grade - 1}级`, class_total: 0 },
        { term_name: `中专三年级${this.grade - 2}级`, class_total: 0 }
      ]
    }
  },

  mounted() {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.trial-framework {
  .level {
    position: relative;
    padding-left: 90px;
    line-height: 32px;

    & + .level {
      margin-top: 20px;
    }

    .level-branch {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 32px;
    }

    .level-grade {
      position: relative;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      font-weight: 500;

      @media screen and (max-width: $mobile-max-width) {
        flex-flow: column;
        justify-content: flex-start;
      }

      &:before {
        position: absolute;
        left: -22px;
        top: 15px;
        content: '';
        width: 13px;
        height: 1px;
        background-color: #979797;
      }
      &:after {
        position: absolute;
        left: -22px;
        top: 0;
        bottom: 0;
        content: '';
        width: 1px;
        background-color: #979797;
      }
      &:first-of-type {
        &:before {
          left: -35px;
          width: 26px;
        }
        &:after {
          top: 15px;
        }
      }
      &:last-of-type {
        &:after {
          bottom: auto;
          height: 16px;
        }
      }

      &:last-child {
        padding-bottom: 0;
      }

      b {
        margin-left: 10px;
        margin-right: 20px;
        font-weight: 400;
        color: #999;
      }

      .count {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: 400;
        .el-input {
          display: inline-block;
          width: 60px;
          margin: 0 10px;
        }
      }
    }
  }

  .frame-tip {
    margin-top: 20px;
    color: #999;
    font-size: 12px;
  }
}
</style>
